import React from 'react';
import PropTypes from 'prop-types';

import Button from '../formElements/Button';
import sAction from 'sAction';

export default function ViewSelect({views}) {
    let selectedView;

    views.forEach((view) => {
        if (window.location.href.includes(view.link)) {
            selectedView = view;
        }
    });

    return (
        <div className='deviceSelectContainer'>
            {views.map((view, index) => (
                <a href={view.link} key={index} title={sAction.translate(view.title)}>
                    <Button type="button" className={(view === selectedView)? 'acmButton selected': 'acmButton'}>
                        <div className={`buttonIcon icon-${view.icon}`}/>
                    </Button>
                </a>
            ))}
        </div>
    );
}

ViewSelect.propTypes = {
    views: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            title: PropTypes.string,
        }),
    ).isRequired,
};
